import clsx from "clsx"
import React from "react"

import SplitTextL from "../../patterns/SplitTextLeft"
import Button from "../Button"
import PageGrid from "../PageGrid"

interface TextProps {
  title: string
  description?: string | string[] | React.ReactNode
  valueProps?: {
    rowOne?: Array<React.ReactNode> | Array<string>
    rowTwo?: Array<React.ReactNode> | Array<string>
    rowThree?: Array<React.ReactNode> | Array<string>
  }
  image?: any | React.ReactNode
  buttonCTA?: string
  buttonLink?: string
  bigText?: boolean
  lessHeight?: boolean
  titleClass?: string
}

// Helper function to create a more stable key from content
const createStableKey = (
  content: React.ReactNode | string,
  index: number,
): string => {
  if (typeof content === "string") {
    return `${index}-${content.slice(0, 10).replace(/\s+/g, "")}`
  }
  // For React nodes, use index with a prefix
  return `item-${index}`
}

const ValuePropsSection: React.FC<TextProps> = ({
  title,
  description,
  valueProps,
  image,
  buttonCTA,
  buttonLink,
  bigText,
  lessHeight = false,
  titleClass = "",
}) => (
  <>
    <SplitTextL
      title={title}
      leftDescription={description}
      bigText={bigText}
      wrapperClassLeft={clsx(
        lessHeight ? "pt-5 md:pt-6 lg:pt-14" : "pt-10 lg:pt-28",
        titleClass,
      )}
    />
    <div
      className={clsx(
        lessHeight ? "pt-5 md:pt-6 lg:pt-14" : "py-12 md:py-20 lg:py-28",
      )}
    >
      <PageGrid>
        {valueProps.rowOne.map((values, index) => (
          <div
            className={clsx(
              image ? "col-span-2 lg:col-span-4" : "col-span-2 lg:col-span-6",
            )}
            key={createStableKey(values, index)}
          >
            {values}
          </div>
        ))}
        {image ? (
          <div className="relative hidden col-span-2 p-4 lg:block md:col-span-4">
            {image}
          </div>
        ) : (
          ""
        )}
      </PageGrid>
      {valueProps.rowTwo && (
        <>
          <PageGrid>
            {valueProps.rowTwo.map((values, index) => (
              <div
                className={clsx(
                  image
                    ? "col-span-2 lg:col-span-4"
                    : "col-span-2 lg:col-span-6",
                )}
                key={createStableKey(values, index)}
              >
                {values}
              </div>
            ))}
          </PageGrid>
          {image && (
            <PageGrid>
              <div className="relative block p-4 lg:hidden col-span-full">
                {image}
              </div>
            </PageGrid>
          )}
        </>
      )}
      {valueProps.rowThree ? (
        <PageGrid>
          {valueProps.rowThree.map((values, index) => (
            <div
              className={clsx(
                image ? "col-span-2 lg:col-span-4" : "col-span-2 lg:col-span-6",
              )}
              key={createStableKey(values, index)}
            >
              {values}
            </div>
          ))}
        </PageGrid>
      ) : (
        ""
      )}
      {buttonLink ? (
        <div className="mt-16 text-center col-span-full">
          <Button to={buttonLink}>{buttonCTA}</Button>
        </div>
      ) : (
        ""
      )}
    </div>
  </>
)

export default ValuePropsSection
